import _ from "lodash";

export const addRevision = (state: any) => {
  if (_.isNull(state.revision)) return;
  state.revision += 1;
};
